import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";

// css
import styles from "./CashoutMod.module.scss";


const CashoutMod = (props) => {
  const [selectedOption, setselectedOption] = useState("standard")

  return (
    <>
      <Modal
        {...props}
        className={`${styles.CashoutMod} transparentModal`}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <h5 className="m-0">Payment Option</h5>
        </Modal.Header>
        <Modal.Body className="">
          <div className=" p-3">
            <Form>
              <Row>
                <Col lg="12" className="my-2">
                  <ul className="list-unstyled ps-0 mb-0 d-flex gap-3 flex-column mx-auto">
                    <li>
                      <div className={`optionDiv  rounded px-3 py-2 ${selectedOption === "standard" && 'active_payment'}`} onClick={() => {
                        setselectedOption("standard")
                      }}>
                        <h5>Standard</h5>

                        <p>Receive your earnings in 1-3 business days directly to your bank account with no fee.</p>
                      </div>
                    </li>

                    <li>
                      <div className={`optionDiv  rounded px-3 py-2 ${selectedOption === "instant" && 'active_payment'}`} onClick={() => {
                        setselectedOption("instant")
                      }}>
                        <h5>Instant</h5>

                        <p>Get your funds instantly via Stripe for a 1.5% fee (minimum $0.50 per transfer).</p>
                      </div>
                    </li>
                  </ul>
                </Col>

              </Row>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>

          <Button className="d-inline-flex align-items-center justify-content-center commonBtn mx-auto" onClick={() => {
            props.handleVendorPayout({ type: selectedOption })
          }} disabled={props.loader}
          >
            {props.loader ? "Processing..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal >
    </>
  );
};

export default CashoutMod;
